import { ReactElement } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import classNames from 'classnames';

import { DEFAULT_SKELETON_ANIMATION_SPEED } from '^configs/contentLoader';

import styles from './styles.module.scss';

export type IPageSkeletonProps = IContentLoaderProps;

const PageSkeleton = ({ className, ...rest }: IPageSkeletonProps): ReactElement => (
  <div className={styles.wrapper}>
    <ContentLoader
      className={classNames(styles.skeletonBase, className)}
      speed={DEFAULT_SKELETON_ANIMATION_SPEED}
      backgroundColor="currentColor"
      {...rest}
    >
      <rect
        width="15%"
        height="16"
        rx="4"
      />

      <rect
        y="32"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="64"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="112"
        width="15%"
        height="16"
        rx="4"
      />

      <rect
        y="144"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="176"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="224"
        width="15%"
        height="16"
        rx="4"
      />

      <rect
        y="256"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="288"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="336"
        width="15%"
        height="16"
        rx="4"
      />

      <rect
        y="368"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="400"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="448"
        width="15%"
        height="16"
        rx="4"
      />

      <rect
        y="480"
        width="100%"
        height="16"
        rx="4"
      />

      <rect
        y="512"
        width="100%"
        height="16"
        rx="4"
      />

    </ContentLoader>
  </div>
);

export default PageSkeleton;
